import { trpc } from '@tencent/tpro_rmonitor_product_manager_approval';
import { get } from 'lodash-es';
import AbstractHttpClient from '@/infrastructure/axios/request';
import { TrpcService } from '@/service/trpc';
import { WithTypeCast } from '@raft/utils';
type IApplication = WithTypeCast<trpc.rmonitor.product_manager.IApplication>;
type IApplyProductRoleReq = WithTypeCast<trpc.rmonitor.product_manager.IApplyProductRoleReq>;
type IGetApprovalListByProductReq = WithTypeCast<trpc.rmonitor.product_manager.IGetApprovalListByProductReq>;
type IApproveReq = WithTypeCast<trpc.rmonitor.product_manager.IApproveReq>;
type IRejectReq = WithTypeCast<trpc.rmonitor.product_manager.IRejectReq>;

/**
 * 产品成员管理
 */
export class ApprovalService extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: TrpcService.ApprovalService,
    });
  }

  /**
   * 获取某个产品下审批列表
   */
  public async getApprovalListByProduct(req: IGetApprovalListByProductReq): Promise<IApplication[]> {
    try {
      const rsp = await this.trpcPost('GetApprovalListByProduct', req);
      return get(rsp, 'approvalList', []);
    } catch (e) {
      return [];
    }
  }

  /**
   * 获取所有审批列表
   */
  public async getApprovalList(): Promise<IApplication[]> {
    try {
      const rsp = await this.trpcPost('GetApprovalList');
      return get(rsp, 'approvalList', []);
    } catch (e) {
      return [];
    }
  }

  /**
   * 申请权限
   */
  public async applyProductRole(req: IApplyProductRoleReq): Promise<boolean> {
    try {
      await this.trpcPost('ApplyProductRole', req);
      return true;
    } catch (e) {
      return false;
    }
  }

  /**
   * 同意申请
   */
  public async approve(req: IApproveReq): Promise<boolean> {
    try {
      await this.trpcPost('Approve', req);
      return true;
    } catch (e) {
      return false;
    }
  }

  /**
   * 驳回申请
   */
  public async reject(req: IRejectReq): Promise<boolean> {
    try {
      await this.trpcPost('Reject', req);
      return true;
    } catch (e) {
      return false;
    }
  }
}

export const approvalService = new ApprovalService();
